import { lazy } from "react";
import { useParams } from "react-router-dom";


const WebsiteRoot = lazy(() => import("../../website/WebsiteRoot"));

interface Props {
  pageId: number;
}

const PageRenderer: React.FC<Props> = ({ pageId }) => {
  console.log("🚀 PageRenderer rendered with pageId:", pageId);

  return (
    <div>
      <WebsiteRoot userBusinessId={pageId} />
    </div>
  );
};


export default PageRenderer;
